module.exports = __webpack_public_path__ + "static/media/conversational-intelligence-platform.71193202.png";